import React, { forwardRef } from 'react';
import {
  FormControlLabel,
  RadioGroup as MuiRadioGroup,
  RadioGroupProps as MuiRadioGroupProps,
} from '@mui/material';
import { RadioV2 } from './RadioV2';

type Option = {
  readonly value: string;
  readonly label: string;
};

export type RadioProps = {
  readonly options: Option[];
  readonly row?: boolean;
  readonly disabled?: boolean;
} & MuiRadioGroupProps;

// 모양은 RadioV2 에 위임 — 여기서는 options 배열이라는 기존 시그니처만 유지.
const Radio = forwardRef<HTMLDivElement, RadioProps>(
  ({ options, disabled, sx, ...field }, ref) => {
    return (
      <MuiRadioGroup
        {...field}
        ref={ref}
        sx={{
          '.MuiButtonBase-root': {
            display: 'flex',
            margin: 0,
            padding: 0,
          },
          '.MuiFormControlLabel-root': {
            padding: '0',
            margin: '0 24px 0 0',
            gap: '8px',
          },
          input: {
            width: '1px',
            height: '1px',
          },
          ...sx,
        }}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<RadioV2 disabled={disabled} />}
            label={option.label}
          />
        ))}
      </MuiRadioGroup>
    );
  },
);

Radio.displayName = 'Radio';
export default Radio;
